import { Box, Container } from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import JsonTextEditor from "./JsonTextEditor";
import { API_ENDPOINT } from "../../utils/constants";

const TemplateCreatorRaw = () => {
  return (
    <Container maxWidth="md">
      <BackBtn />
      <PageTitle>Template Creator Raw</PageTitle>
      <Box mt={1}>
        <JsonTextEditor
          apiEndpoint={`${API_ENDPOINT}/api/create-template-raw`}
          onSuccess={(response) => {
            console.log("response", response);
          }}
        />
      </Box>
    </Container>
  );
};

export default TemplateCreatorRaw;
